export default "__VITE_ASSET___zwuNKD3__"